export const TOGGLE_MESSAGE = 'TOGGLE_MESSAGE'

export function toggleMessage() {
	return {
		type: TOGGLE_MESSAGE,
	}
}



// WEBPACK FOOTER //
// ./src/toggle/actions.js